module.exports = __webpack_public_path__ + "static/media/wab32_1012.4cbb3ec3.ico";